import React from 'react';
import { selectLINKtivityAccessAllowed } from '../../../common/subscription/SubscriptionSlice';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Breadcrumbs,
  Link,
  TextField,
  InputAdornment,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import PageTitle from '../../../common/components/PageTitle';
import LinktivityCard from '../LinktivityCard';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchCategoryList } from '../../../common/api/linktivities';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { LTVLIBHOME } from '../../../routes/CONSTANTS';
import PreviewMode from '../PreviewMode';
import SearchIcon from '@mui/icons-material/Search';
import WarningIcon from '@mui/icons-material/WarningAmber';

const BackButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(5),
}));

export function LtvLibCategory() {
  const LINKtivityAccessAllowed = useSelector(selectLINKtivityAccessAllowed);
  const { id, name } = useParams();
  const [categoryList, setCategoryList] = useState([]);
  const [filteredCategoryList, setFilteredCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const categoryId = id;
  const categoryName = name;

  useEffect(() => {
    setLoading(true);
    fetchCategoryList(id)
      .then((res) => {
        var tempCatagoryList = res.data;
        tempCatagoryList.sort(function (a, b) {
          return a.linktivity_name
            .toLowerCase()
            .localeCompare(b.linktivity_name.toLowerCase());
        });
        setCategoryList(tempCatagoryList);
        setFilteredCategoryList(tempCatagoryList);
      })
      .catch((err) => {
        setCategoryList([]);
        setFilteredCategoryList([]);
      })
      .finally(() => {
        setLoading(false);
        window.scrollTo(0, 0);
      });
  }, [id]);

  const handleBackToLibHomeClick = (event) => {
    event.preventDefault();
    navigate(LTVLIBHOME);
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    if (searchValue) {
      const filteredList = categoryList.filter((item) => {
        return item.linktivity_name.toLowerCase().includes(searchValue);
      });
      setFilteredCategoryList(filteredList);
    } else {
      setFilteredCategoryList(categoryList);
    }
  };

  return (
    <>
      <Breadcrumbs
        aria-label='breadcrumb'
        sx={{ paddingBottom: 2 }}
        separator={<ChevronRightIcon />}
      >
        <Link
          underline='hover'
          key='1'
          color='inherit'
          component={RouterLink}
          to={LTVLIBHOME}
        >
          Library Home
        </Link>
        ,
        <Typography key='2' color='primary.main'>
          {categoryName}
        </Typography>
      </Breadcrumbs>
      <PageTitle
        title={
          LINKtivityAccessAllowed
            ? name + ' LINKtivities'
            : name + ' LINKtivities - PREVIEW'
        }
      />
      {loading ? (
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <CircularProgress color='secondary' />
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid
            container
            spacing={1}
            direction='row'
            alignItems='center'
            justifyContent='center'
            sx={{ marginBottom: '20px' }}
          >
            <Grid item xs={0} md={1}></Grid>

            <Grid item xs={12} md={7}>
              <Typography>
                Click on a LINKtivity® card to view the details about that
                LINKtivity®
              </Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                id='category-search'
                placeholder={'Search ' + categoryName}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                variant='outlined'
                sx={{ width: '100%', maxWidth: '400px' }}
                onKeyUp={handleSearch}
              />
            </Grid>
            <Grid item xs={0} md={1}></Grid>
          </Grid>
          {!filteredCategoryList.length && (
            <Grid container spacing={10}>
              <Grid item xs={12}>
                <WarningIcon sx={{ width: '5vw', height: 'auto' }} />
                <Typography>No results</Typography>
              </Grid>
            </Grid>
          )}
          <Grid
            container
            spacing={1}
            direction='row'
            alignItems='center'
            justifyContent='center'
          >
            {filteredCategoryList.map((linktivity) => (
              <Grid item key={linktivity.linktivity_id}>
                <Grid
                  container
                  spacing={0}
                  direction='row'
                  alignItems='center'
                  justifyContent='center'
                >
                  <Grid item sx={{ margin: '5px' }}>
                    <LinktivityCard
                      id={linktivity.linktivity_id}
                      name={linktivity.linktivity_name}
                      categoryId={categoryId}
                      categoryName={categoryName}
                      thumbnail={linktivity.thumbnail_image_link}
                      featured={
                        linktivity.featured ? linktivity.featured : false
                      }
                      isnew={linktivity.new ? linktivity.new : false}
                    />
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
          {!LINKtivityAccessAllowed && <PreviewMode />}
          <BackButton variant='contained' onClick={handleBackToLibHomeClick}>
            <ArrowBackIcon style={{ marginRight: '5' }} />
            Back to Categories
          </BackButton>
        </>
      )}
    </>
  );
}
